import { createStyles } from '@material-ui/core/styles';

export default createStyles({
    container: {
        width: '97%',
        height: 'calc(100% - 195px)',
    }
});
